export default __webpack_public_path__ + "static/media/mysql.392a8a6d.svg";